module.exports = __webpack_public_path__ + "static/media/pinred.a8ef9856.png";